import React from 'react';
import { createRoot } from 'react-dom/client';
import './legacy/styles.css';

window.React = React;
window.ReactDOM = { createRoot };

async function boot() {
  await import('./legacy/mock-data.js');
  // PR-1/2/3/5: backend hooks 먼저 로드해서 window.* 글로벌 등록.
  await import('./hooks/use-screening-today.js');
  await import('./hooks/use-pillar-scores.js');
  await import('./hooks/use-realtime-rankings.js');
  await import('./hooks/use-market.js');
  await import('./hooks/use-market-sectors.js');
  await import('./hooks/use-market-sector-stocks.js');
  await import('./hooks/use-market-heatmap.js');
  await import('./hooks/use-stock-snapshot.js');
  await import('./hooks/use-news-feed.js');
  await import('./hooks/use-stock-chart.js');
  await import('./hooks/use-stock-flows.js');
  await import('./hooks/use-stock-risk-flags.js');
  await import('./hooks/use-stock-reference-features.js');
  await import('./hooks/use-stock-technical-summary.js');
  await import('./hooks/use-stock-fundamentals.js');
  await import('./hooks/use-stock-events.js');
  await import('./hooks/use-recent-alerts.js');
  await import('./hooks/use-screening-performance.js');
  await import('./hooks/use-candidate-tracking.js');
  await import('./hooks/use-morning-report.js');
  await import('./hooks/use-watchlist.js');
  await import('./hooks/use-analysis.js');
  await import('./hooks/use-auth.js');
  await import('./hooks/use-invites.js');
  await import('./hooks/use-admin-users.js');
  await import('./hooks/use-screening-settings.js');
  await import('./hooks/use-notification-settings.js');
  await import('./hooks/use-realtime-connection.js');
  await import('./legacy/components-shared.jsx');
  await import('./legacy/pillar-components.jsx');
  await import('./legacy/tweaks-panel.jsx');
  await import('./legacy/market-desk.jsx');
  await import('./legacy/mobile-desk.jsx');
  await import('./legacy/watchlist.jsx');
  await import('./legacy/stock-detail.jsx');
  await import('./legacy/reports-settings.jsx');
  await import('./legacy/sector-trends.jsx');
  await import('./legacy/market-treemap.jsx');
  await import('./legacy/macro-ticker.jsx');
  await import('./legacy/admin.jsx');
  await import('./legacy/app.jsx');
}

boot().catch((error) => {
  console.error(error);
  const root = document.getElementById('root');
  if (root) {
    root.innerHTML = '<div style="padding:24px;font-family:sans-serif">StockView 화면을 불러오지 못했습니다.</div>';
  }
});
